import dayjs from "dayjs";
import { CalendarDays, CalendarX } from "lucide-react";
import Panel, { Empty } from "./Panel";
import { cn } from "../../../utils/tailwindUtils";

const STATE = {
    missed:    { label: "No show",        cls: "text-red-700 bg-red-50 dark:bg-red-900/30 dark:text-red-300" },
    past_due:  { label: "Log outcome",    cls: "text-amber-700 bg-amber-50 dark:bg-amber-900/30 dark:text-amber-300" },
    scheduled: { label: "Scheduled",      cls: "text-sky-700 bg-sky-50 dark:bg-sky-900/30 dark:text-sky-300" },
};

const dayLabel = (d) => {
    const day = dayjs(d);
    if (day.isSame(dayjs(), "day")) return "Today";
    if (day.isSame(dayjs().add(1, "day"), "day")) return "Tomorrow";
    if (day.isSame(dayjs().subtract(1, "day"), "day")) return "Yesterday";
    return day.format("ddd");
};

// Demos needing a decision first (missed, or held but not logged), then the
// next seven days in time order.
const UpcomingDemos = ({ demos, loading, onOpen, onViewAll }) => (
    <Panel title="Demos" icon={CalendarDays} loading={loading} action="Calendar" onAction={onViewAll}>
        {!demos?.length ? (
            <Empty icon={CalendarX} title="No demos this week"
                   hint="Qualified leads are your best bet to book one." />
        ) : (
            <ul className="space-y-1.5">
                {demos.map(d => {
                    const s = STATE[d.state] || STATE.scheduled;
                    return (
                        <li key={d.customer_id}
                            onClick={() => onOpen(d.customer_id)}
                            className="flex items-center gap-3 p-2 rounded-xl hover:bg-gray-50 dark:hover:bg-gray-700/40 cursor-pointer">
                            <div className={cn("w-11 flex-shrink-0 rounded-lg text-center py-1",
                                d.state === "scheduled" ? "bg-brand-50 dark:bg-brand-900/30" : "bg-gray-50 dark:bg-gray-700")}>
                                <p className="text-[10px] font-semibold uppercase text-brand-600 dark:text-brand-300">{dayLabel(d.demo_at)}</p>
                                <p className="text-sm font-bold text-gray-900 dark:text-white leading-tight">{dayjs(d.demo_at).format("D")}</p>
                            </div>
                            <div className="flex-1 min-w-0">
                                <p className="text-sm font-medium text-gray-900 dark:text-white truncate">{d.customer_name}</p>
                                <p className="text-xs text-gray-500 dark:text-gray-400">{dayjs(d.demo_at).format("h:mm A")}</p>
                            </div>
                            <span className={cn("text-[10px] font-semibold px-1.5 py-0.5 rounded whitespace-nowrap", s.cls)}>{s.label}</span>
                        </li>
                    );
                })}
            </ul>
        )}
    </Panel>
);

export default UpcomingDemos;
